var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useMemo } from 'react';
import { useGetConversationsQuery } from '../../../../application/features/chat/chat-api';
import { setConversationId } from '../../../../application/features/chat/chatSlice';
import { useAppDispatch, useAppSelector } from '../../../../application/store/useStore';
import useTranslate from '../../../../localization/helpers';
import ChatCollapseIcon from '../../../icons/components/collapse-icon';
var ChatHistory = function (_a) {
    var closeDrawer = _a.closeDrawer;
    var theme = useTheme();
    var dispatch = useAppDispatch();
    var translate = useTranslate().translate;
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    var conversation_id = useAppSelector(function (state) { return state.chat; }).conversation_id;
    var _b = useGetConversationsQuery(currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId).data, conversations = _b === void 0 ? [] : _b;
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var groupedConversations = useMemo(function () {
        var today = new Date();
        var yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        return conversations.reduce(function (groups, conversation) {
            var groupKey;
            var conversationDate = new Date(conversation.time);
            if (today.toDateString() === conversationDate.toDateString())
                groupKey = translate('chat.today');
            else if (yesterday.toDateString() === conversationDate.toDateString())
                groupKey = translate('chat.yesterday');
            else
                groupKey = translate('chat.older');
            if (!groups[groupKey])
                groups[groupKey] = [];
            groups[groupKey].push(conversation);
            return groups;
        }, {});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [conversations]);
    var getConversation = function (conversation_id) { return dispatch(setConversationId(conversation_id)); };
    return (_jsxs(Box, { padding: '16px', display: 'block', width: '100%', height: '100%', sx: {
            backgroundColor: '#FFFFFF'
        }, borderRadius: '24px', children: [_jsxs(Box, { display: 'flex', flexDirection: 'row', justifyContent: 'space-between', sx: { backgroundColor: theme.palette.background.default, position: 'sticky', top: 0 }, children: [_jsx(Typography, { variant: 'h5', children: translate('chat.chatHistory') }), _jsx(IconButton, { size: 'small', onClick: closeDrawer, children: _jsx(ChatCollapseIcon, { style: { transform: isXs ? 'rotate(-90deg)' : '' } }) })] }), _jsx(Box, { height: '100%', paddingBottom: '40px', sx: { overflowY: 'auto' }, children: Object.entries(groupedConversations).map(function (_a) {
                    var _b = __read(_a, 2), groupKey = _b[0], conversations = _b[1];
                    return (_jsxs(Box, { pt: 1, display: 'flex', flexDirection: 'column', children: [_jsx(Typography, { fontSize: '13px', color: '#919EAB', fontWeight: '400', children: groupKey.charAt(0).toUpperCase() + groupKey.slice(1) }), conversations.map(function (chat, index) { return (_jsx(Box, { onClick: function () {
                                    getConversation(chat.conversation_id);
                                    closeDrawer();
                                }, p: 1, mt: 2, display: 'flex', flexDirection: 'row', alignContent: 'center', justifyContent: 'flex-start', sx: {
                                    backgroundColor: conversation_id === chat.conversation_id ? '#F4F6F8' : '#FFFFFF',
                                    '&:hover': {
                                        backgroundColor: '#F4F6F8',
                                        cursor: 'pointer'
                                    }
                                }, borderRadius: '12px', children: _jsx(Typography, { fontSize: '13px', color: '#161C24', variant: 'body1', children: chat.conversation_name }) }, index)); })] }, groupKey));
                }) })] }));
};
export default ChatHistory;
